import { useMutation } from "@tanstack/react-query";

import { resetPasswordRequest } from "../requests/reset-password-request";

export const useResetPasswordMutation = () => {
  return useMutation({
    mutationFn: resetPasswordRequest,
  });
};
